import { useEffect } from "react"
import * as CookieConsent from "vanilla-cookieconsent"

export const initCookieConsent = () => {
  const cc = CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: "box inline",
        position: "bottom right",
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: "box",
        equalWeightButtons: true,
        flipButtons: false
      },
    },
    categories: {
      necessary: {
        readOnly: true,
        enabled: true,
        services: {
          cc: {
              label: "CookieConsent",
          },
        },
      },
    },
    language: {
      default: "",
      translations: {
        "": {
          consentModal: {
            label: "Cookie Consent",
            title: "Cookiehinweis",
            description: "Diese Website verwendet essenzielle Cookies, um ihren ordnungsgemässen Betrieb zu gewährleisten.",
            acceptAllBtn: "Alle akzeptieren",
            showPreferencesBtn: "Einstellungen",
            footer: "<a href=\"/datenschutz\">Datenschutz</a>"
          },
          preferencesModal: {
            title: "Cookie-Einstellungen",
            acceptAllBtn: "Alle akzeptieren",
            savePreferencesBtn: "Speichern",
            closeIconLabel: "Schliessen",
            serviceCounterLabel: "Service|Services",
            sections: [
              {
                  title: "Erklärung 📢",
                  description: 'Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und um Ihr Online-Erlebnis zu verbessern. Sie können für jede Kategorie wählen, ob Sie sich ein- oder austragen möchten. Für weitere Einzelheiten zu Cookies und anderen sensiblen Daten lesen Sie bitte die vollständige <a class="cc- link" href="/datenschutz">Datenschutz</a>.',
              },
              {
                  title: "Zwingende Cookies",
                  description: "Diese Cookies werden für die Funktionalität der Webseite zwingend benötigt.",
                  linkedCategory: "necessary",
                  cookieTable: {
                    headers: {
                      name: "Cookie",
                      Service: "Service",
                      description: "Beschreibung",
                      Website: "Website"
                    },
                    body: [
                      {
                        name: "cc_cookie",
                        description: "Wird verwendet um zu speichern, welche Cookie-Optionen angenommen / abgelehnt wurden.",
                        Service: "CookieConsent",
                        Website: "cookieconsent.orestbida.com"
                      },
                    ]
                  }
              },
            ]
          },
        },
      },
    },
  })

  return cc
}

export function CookieConsentProvider() {
  useEffect(() => {
    initCookieConsent()
  }, [])

  return null
}